import React from 'react';
import { __DEV__ } from '../Constants';

export default function LayzCalendar(props) {
  if (__DEV__) {
    const Calendar = require('./Calendar').default
    return <Calendar {...props} />
  }
  return <div />
}